export default "__VITE_ASSET__CetvDLVk__"